import DashboardWidgets from "./js/DashboardWidgets";
export default DashboardWidgets;